import $ from 'jquery';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';

import {assertAndContinue} from 'Asserts';
import {isBrowser} from 'lib/Browser';

export interface ClickOutWrapperProps {
  children: React.ReactNode;
  shouldCloseOnInsideClick?: boolean;
  onClickOut: () => void;
}

export default class ClickOutWrapper extends React.Component<ClickOutWrapperProps> {
  static defaultProps = {
    shouldCloseOnInsideClick: false,
  };

  static propTypes = {
    children: PropTypes.element.isRequired,
    shouldCloseOnInsideClick: PropTypes.bool.isRequired,
    onClickOut: PropTypes.func.isRequired,
  };

  componentDidMount(): void {
    if (isBrowser) {
      window.addEventListener('click', this.handleBodyClick, true);
    }
  }

  componentWillUnmount(): void {
    if (isBrowser) {
      window.removeEventListener('click', this.handleBodyClick, true);
    }
  }

  private handleBodyClick = (e: MouseEvent): void => {
    const node = ReactDOM.findDOMNode(this);
    if (!assertAndContinue(node != null, 'Expected component to be mounted')) {
      return;
    }
    const $node = $(node!);
    const inDOMNode = $(e.target!).closest($node).length > 0;
    if (this.props.shouldCloseOnInsideClick || !inDOMNode) {
      this.props.onClickOut();
    }
  };

  render(): React.ReactNode {
    return this.props.children;
  }
}
